import 'urlpattern-polyfill'
import 'regenerator-runtime/runtime' // para async/await
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import Router from './route';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import DracofyTracker from './components/Tracking/DracofyTracker';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <DracofyTracker />
        <Router />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
